import RewindJob, { RewindJobStatuses } from '../../../../types/api/rewind-job'

export function isRewindJobCopiesEditable(rewindJob?: RewindJob): boolean {
    return (
        rewindJob?.jobStatus === RewindJobStatuses.Created ||
        rewindJob?.jobStatus === RewindJobStatuses.Planned
    )
}
